import mermaid from 'mermaid';

// Stores rendered diagrams to prevent re-rendering
// Key: hash of diagram code, Value: rendered SVG
export const globalDiagramCache: { [key: string]: string } = {};

// Stores visibility state for each diagram
// Key: hash of diagram code, Value: boolean showing if diagram is visible
export const globalDiagramVisibility: { [key: string]: boolean } = {};

// Locks to prevent race conditions during rendering
export const renderingInProgress: { [key: string]: boolean } = {};

// Create a more robust unique key generator
export const createDigestKey = (content: string): string => {
  // Simple but effective hash for diagram content
  let hash = 0;
  for (let i = 0; i < content.length; i++) {
    const char = content.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return 'mermaid-' + Math.abs(hash).toString(16);
};

// Add a global style for centering mermaid diagrams
const addMermaidCenteringStyles = () => {
  if (!document.getElementById('mermaid-centering-styles')) {
    const styleEl = document.createElement('style');
    styleEl.id = 'mermaid-centering-styles';
    styleEl.textContent = `
      .mermaid-diagram-container svg {
        display: block !important;
        margin: 0 auto !important;
        max-width: 100% !important;
      }

      .mermaid-diagram-container > div {
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
      }

      .mermaid svg {
        margin: 0 auto !important;
      }
    `;
    document.head.appendChild(styleEl);
  }
};

// Add styling once when the module loads
addMermaidCenteringStyles();

// Initialize mermaid with standard configuration
// This is safe to call multiple times - Mermaid handles duplicate initialization
mermaid.initialize({
  startOnLoad: false, // We'll manually trigger rendering
  theme: 'default',
  securityLevel: 'loose',
  fontFamily: 'monospace',
});